import type {
  ExtendedConstraints,
  CapabilityConfig,
  Message,
} from '../../types';
import { hasOnlyKeysFromSet, isValidMessageConfig } from '../../utils';

export const id = 'post-install';

export type CustomEventPayload = unknown;

export enum Events {
  CustomEvent = 'post-install:custom-event',
}

export enum Actions {}

export type Config = CapabilityConfig & {
  type: typeof id;
  messages: Message[];
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.CustomEvent, CustomEventPayload];
  eventHandlerTuple:
    | [Events.CustomEvent, (payload: CustomEventPayload) => void];
}>;

const VALID_CONFIG_KEYS = ['type', 'messages'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  if (!Array.isArray(config['messages'])) {
    return false;
  }

  if (!config['messages'].every((m) => isValidMessageConfig(m))) {
    return false;
  }

  return true;
}
